import gsap from 'gsap';

export default class VideoSlider {
    constructor(container) {
        this.container = container;
        this.btnPrev = container.querySelector('[data-action="prev"]');
        this.btnNext = container.querySelector('[data-action="next"]');
        this.slides = Array.from(container.querySelectorAll('.slider-info-video'));

        this.currentIndex = 0;
        this.showSlide(this.currentIndex, false);

        this.addEventListener();
    }

    addEventListener() {
        this.btnPrev.addEventListener('click', this.prevSlide.bind(this));
        this.btnNext.addEventListener('click', this.nextSlide.bind(this));
    }

    prevSlide(e) {
        if (this.currentIndex > 0) {
            this.showSlide(this.currentIndex - 1);
            this.animateArrowButton(e);
        }
    }

    nextSlide(e) {
        if (this.currentIndex < this.slides.length - 1) {
            this.showSlide(this.currentIndex + 1);
            this.animateArrowButton(e);
        }
    }

    animateArrowButton(e) {
        if (!e.currentTarget.dataset.colBg) {
            const colBg = gsap.getProperty(e.currentTarget, 'backgroundColor');
            e.currentTarget.dataset.colBg = colBg;
        }

        const col = gsap.getProperty(e.currentTarget, '--col-bg-contentbtn-active');
        gsap.set(e.currentTarget, { backgroundColor: col });

        gsap.killTweensOf(e.currentTarget);
        gsap.to(e.currentTarget, {
            backgroundColor: e.currentTarget.dataset.colBg,
            duration: 0.65,
            ease: 'power2.inOut',
        });
    }

    showSlide(newIndex, instant = false) {
        const oldSlide = this.slides[this.currentIndex];
        const newSlide = this.slides[newIndex];

        if (oldSlide && oldSlide !== newSlide) {
            const oldVideo = oldSlide.querySelector('video');
            if (oldVideo) {
                oldVideo.pause();
                // oldVideo.currentTime = 0;
            }

            oldSlide.style.zIndex = 1;
            gsap.to(oldSlide, {
                autoAlpha: 0,
                duration: instant ? 0 : 0.5,
                onComplete: () => {
                    oldSlide.style.zIndex = 0;
                },
            });
        }

        if (newSlide) {
            const newVideo = newSlide.querySelector('video');

            if (newVideo) {
                const playVideo = () => {
                    newVideo.currentTime = 0;
                    gsap.fromTo(
                        newSlide,
                        { autoAlpha: 0 },
                        {
                            autoAlpha: 1,
                            duration: instant ? 0 : 0.5,
                        }
                    );
                    newVideo.play().catch((err) => {
                        if (err.name !== 'AbortError') console.error(err);
                    });
                };

                if (newVideo.dataset.ready === 'true' || newVideo.readyState >= 2) {
                    playVideo();
                    gsap.fromTo(
                        newSlide,
                        { autoAlpha: 0 },
                        {
                            autoAlpha: 1,
                            duration: instant ? 0 : 0.5,
                        }
                    );
                } else {
                    newVideo.addEventListener('loadeddata', playVideo, { once: true });
                }
            }

            newSlide.style.zIndex = 2;
        }

        this.currentIndex = newIndex;
        this.setButtonState(this.btnPrev, newIndex > 0);
        this.setButtonState(this.btnNext, newIndex < this.slides.length - 1);
    }

    setButtonState(button, isEnabled) {
        if (!button) return;
        button.style.opacity = isEnabled ? '1' : '0.1';
        button.style.pointerEvents = isEnabled ? 'auto' : 'none';
    }
}
